<script>
const ONGOING = ['CURRENT', 'AKTUELL'];

export default {
  props: {
    entries: Array,
  },

  methods: {
    isOngoing(entry) {
      return ONGOING.includes(entry.end);
    }
  }
}
</script>

<template>
  <ol class="timeline">
    <li v-for="entry in entries" :key="entry.start + entry.title" class="entry"
        :class="{ongoing: isOngoing(entry)}">
      <span class="marker"></span>

      <div class="entry-card">
        <span class="entry-date">
          {{ entry.start }} – <span :class="{'text-now': isOngoing(entry)}">{{ entry.end }}</span>
        </span>
        <h3 class="entry-title">{{ entry.title }}</h3>
        <h4 class="entry-subtitle">{{ entry.subTitle }}</h4>

        <ul v-if="entry.text && entry.text.length" class="entry-points">
          <li v-for="text in entry.text" :key="text">{{ text }}</li>
        </ul>
      </div>
    </li>
  </ol>
</template>

<style scoped>
.timeline {
  --marker: 18px;
  --line-x: 8px;

  position: relative;
  max-width: 900px;
  margin: 0 auto 4rem;
  padding: 0 1rem;
  list-style: none;
}

/* the vertical line */
.timeline::before {
  content: "";
  position: absolute;
  top: 0.5rem;
  bottom: 0.5rem;
  left: calc(1rem + var(--line-x));
  width: 2px;
  background: linear-gradient(to bottom, var(--bs-primary), rgba(13, 110, 253, 0.15));
}

.entry {
  position: relative;
  padding-left: 2.75rem;
  margin-bottom: 1.5rem;
}

.entry:last-child {
  margin-bottom: 0;
}

.marker {
  position: absolute;
  top: 1.6rem;
  left: calc(var(--line-x) - var(--marker) / 2 + 1px);
  width: var(--marker);
  height: var(--marker);
  border-radius: 50%;
  background: #fff;
  border: 3px solid var(--bs-primary);
}

.ongoing .marker {
  background: var(--bs-primary);
  box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.5);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  70% { box-shadow: 0 0 0 10px rgba(13, 110, 253, 0); }
  100% { box-shadow: 0 0 0 0 rgba(13, 110, 253, 0); }
}

@media (prefers-reduced-motion: reduce) {
  .ongoing .marker {
    animation: none;
  }
}

.entry-card {
  padding: 1.25rem 1.5rem;
  border-radius: 1rem;
  background: #fff;
  border: 1px solid rgba(17, 17, 17, 0.08);
  box-shadow: 0 2px 10px rgba(17, 17, 17, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.entry-card:hover {
  transform: translateX(4px);
  border-color: var(--bs-primary);
  box-shadow: 0 10px 28px rgba(13, 110, 253, 0.14);
}

.entry-date {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.2rem 0.75rem;
  border-radius: 999px;
  color: var(--bs-primary);
  background: rgba(13, 110, 253, 0.08);
  margin-bottom: 0.6rem;
}

.entry-date span {
  color: inherit;
}

.ongoing .entry-date,
.ongoing .entry-date span {
  color: #fff;
  background: var(--bs-primary);
}

.entry-title {
  font-size: 1.35rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
}

.entry-subtitle {
  font-size: 1rem;
  font-weight: 600;
  color: var(--bs-primary);
  margin-bottom: 0;
}

.entry-points {
  margin: 0.85rem 0 0;
  padding-left: 1.1rem;
}

.entry-points li {
  font-size: 1rem;
  line-height: 1.55;
  color: #444;
  margin-bottom: 0.25rem;
}

.entry-points li::marker {
  color: var(--bs-primary);
}

@media only screen and (max-width: 575px) {
  .entry {
    padding-left: 2.25rem;
  }

  .entry-card {
    padding: 1rem 1.1rem;
  }

  .entry-title {
    font-size: 1.2rem;
  }
}
</style>
